import React from 'react';
import PropTypes from 'prop-types';
import Formsy from 'formsy-react';
import TrashIcon from 'react-icons/lib/fa/trash-o';
import idx from 'idx';

// import { objToArr } from '../../helpers';
import Input from '../Formsy/Input';
import InspectorSection from './InspectorSection';
import theme from '../../themes/green';
import RangeInput from '../Formsy/RangeInput';
import { Checkbox } from '../Formsy';
import { Button } from '../../components/UIKit';

class PortalMapWidgetEditor extends React.Component {
  constructor() {
    super();
    this.state = {
      canSubmit: false,
    };

    this.onValidSubmit = this.onValidSubmit.bind(this);
    this.enableButton = this.enableButton.bind(this);
    this.disableButton = this.disableButton.bind(this);
    this.onRemove = this.onRemove.bind(this);
  }

  onRemove() {
    this.props.onRemove(this.props.element);
  }

  onReset(fields) {
    const model = this.form.getModel();
    this.form.reset({ ...model, ...fields });
  }

  onValidSubmit(data) {
    this.props.onValidSubmit(data, this.props.path);
  }

  disableButton() {
    this.setState({ canSubmit: false });
  }

  enableButton() {
    this.setState({ canSubmit: true });
  }

  render() {
    const { name = '' } = idx(this.props.project, _ => _.scenes[this.props.element.sceneId]);
    return (
      <Formsy
        onValid={this.enableButton}
        onInvalid={this.disableButton}
        onValidSubmit={this.onValidSubmit}
        style={{ width: '100%' }}
        ref={(component) => {
          this.form = component;
        }}
      >
        <h5 style={{ margin: '10px' }}> {name} </h5>
        <InspectorSection onReset={this.onReset} title={'Portal name'}>
          <Input
            name="name"
            placeholder="Widget name..."
            style={{
              color: theme.pallete.background,
              borderBottom: `2px solid ${theme.pallete.lightBackground}`,
              wrapper: { margin: 0 },
            }}
            /* forceBackground */
            value={this.props.element.name || ''}
          />
        </InspectorSection>
        <InspectorSection onReset={this.onReset} title={'Camera'}>
          <RangeInput
            maxValue={1000}
            minValue={0}
            name="altitude"
            label=""
            value={this.props.element.altitude || 0}
          />
        </InspectorSection>
        <InspectorSection onReset={this.onReset} title={'Home portal'}>
          <Checkbox
            name="isMain"
            value={this.props.element.isMain || false}
            disabled={this.props.element.isMain}
          />
        </InspectorSection>
        <div
          style={{
            display: 'flex',
            flexDirection: 'row',
            justifyContent: 'center',
            alignItems: 'center',
          }}
        >
          <Button
            type="submit"
            style={{
              background: 'rgb(45,228,136)',
              marginLeft: '0px',
            }}
            disabled={!this.state.canSubmit}
          >
            <span style={{ color: 'rgb(72,97,102)' }}>Save</span>
          </Button>
          <Button
            type="button"
            style={{
              background: 'rgb(45,228,136)',
              marginLeft: '0px',
            }}
          >
            <TrashIcon style={{ color: '#476166', cursor: 'pointer' }} onClick={this.onRemove} />
          </Button>
        </div>
      </Formsy>
    );
  }
}

PortalMapWidgetEditor.propTypes = {
  path: PropTypes.string.isRequired,
  element: PropTypes.shape({
    name: PropTypes.string.isRequired,
  }).isRequired,
  onValidSubmit: PropTypes.func,
  project: PropTypes.shape().isRequired,
};

PortalMapWidgetEditor.defaultProps = {
  onValidSubmit: () => {},
};

export default PortalMapWidgetEditor;



// WEBPACK FOOTER //
// ./src/components/Inspector/portalMapWidgetEditor.js